.content {
    width: 70%;
    display: flex;
    flex-direction: column;
    gap: 4px;
}
